<ng-template #defaultPrefixTemplate let-row>
  <div class="prefix" [style.background-color]="row[options.indicatorColorProperty]"></div>
</ng-template>

<ng-template #defaultCardTemplate let-row>
  <div class="table-row-card">
    @if (row[options.titleProperty]) {
    <mat-label class="card-title" [ngClass]="options.stylePropertyPrefix + '-card-table-title'"> {{ row[options.titleProperty] }}</mat-label>
    } @if (row[options.subTitleProperty]) {
    <mat-label class="card-sub-title" [ngClass]="options.stylePropertyPrefix + '-card-table-sub-title'"> {{ row[options.subTitleProperty] }}</mat-label>
    } @if (row[options.additionalProperty]) {
    <mat-label class="card-additional" [ngClass]="options.stylePropertyPrefix + '-card-table-sub-additional'"> {{ row[options.additionalProperty] }}</mat-label>
    } @if (row[options.contentProperty]) {
    <p class="card-content" [ngClass]="options.stylePropertyPrefix + '-card-table-sub-content'"> {{ row[options.contentProperty] }}</p>
    }
  </div>
</ng-template>

<ng-template #defaultRowTemplate let-row>
  <div style="display: flex; justify-content: space-between;">
    @for (property of row; track property; let i = $index) {
    <div
      (click)="sort(property, i)"
      (mouseenter)="onHover(property, true, i)"
      (mouseleave)="onHover(property, false, i)"
      class="heading-wrapper"
      [style.width]="headers != null ? headers[i].Width + '%' : 'auto'"
    >
      <mat-label
        [style.width]="'100%'"
        class="table-row-list-item ellipsis headerText"
        [ngClass]="['action-card-prop-' + property.key, options.textSize]"
        ><app-ellipsis>{{ property.Text }}</app-ellipsis></mat-label
      >
      @if (property.Sortable) {
      <div class="sort-icon"
        >@if (this.headers[i].ShowSorting) {
        <mat-icon
          class="inner-sort-icon"
          [className]="property.SortAscending ? 'arrow-up' : 'arrow-down'"
          [ngClass]="{
            'sort-selected': i == sortedIndex,
            'sort-unselected': i != sortedIndex
          }"
        ></mat-icon>
        }</div
      >
      }
    </div>
    }
    <div id="row-affix-wrapper" style="visibility: hidden;">
      <ng-container #affix *ngTemplateOutlet="affixTemplate; context: {$implicit: row}"> </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #defaultAffixTemplate let-row let-i = "index">
  @if ((options.isSelectable || options.selectAll)) {
    @if(i>0){
      <div class="vertical-wrapper actions-spacer">
        <mat-checkbox color="primary" [checked]="isSelected" (click)="selected()"> </mat-checkbox>
      </div>
    }
  }
</ng-template>

<mat-list-item id="container" lines="none" [ngClass]="{ 'container-wide': layoutService.screenSize > breakpoint }">
  <div class="table-container" [style]="originalStyling && isSideNavCollapsed ? 'width: 90vw' : ''" [ngClass]="{'small-width': !isSideNavCollapsed && originalStyling}">
    <div [ngClass]="{ 'container-height': layoutService.screenSize <= breakpoint }"></div>
    <div id="row-prefix-wrapper">
      <ng-container #prefix *ngTemplateOutlet="prefixTemplate != null ? prefixTemplate : defaultPrefixTemplate; context: row"></ng-container>
    </div>
    @if (layoutService.screenSize <= breakpoint || options.flexCardLayout === true) {
    <div
      id="card-content-wrapper"
      [ngClass]="{
        'content': layoutService.screenSize <= breakpoint || options.flexCardLayout === true,
        'clickable-card': options.clickableFlexCard === true
      }"
    >
      <ng-container #cardContent *ngTemplateOutlet="cardTemplate != null ? cardTemplate : defaultCardTemplate; context: row"></ng-container>
    </div>
    }
    <div id="row-affix-wrapper">
      <ng-container #affix *ngTemplateOutlet="defaultAffixTemplate; context: row"> </ng-container>
    </div>
    @if (layoutService.screenSize > breakpoint && options.flexCardLayout === false) {
    <div id="row-content-wrapper" class="content">
      <ng-container #rowContent *ngTemplateOutlet="rowTemplate != null ? rowTemplate : defaultRowTemplate; context: row"> </ng-container>
    </div>
    }
  </div>
</mat-list-item>
